export default __webpack_public_path__ + "static/media/notes1.f9076235.png";